import React from 'react'
import BrandSelection from './BrandSelection'
import CategoryFilter from './CategoryFilter'

const BrandsAndFilter = () => {
  return (
    <div className="w-full min-h-[50px] flex flex-col md:flex-row items-start justify-between p-5 bg-white-1">
        {/* Cart Section */}
        <div className="w-full md:w-[65%] flex items-center justify-start">
          <BrandSelection />
        </div>

        {/* Category Section */}
        <div className="w-full md:w-[35%] flex items-center justify-end">
          <CategoryFilter />
        </div>
      </div>
  )
}

export default BrandsAndFilter